module.exports = __webpack_public_path__ + "img/CustomerIconv2.7db74e48.png";